export const CreateStatusList = () => [
    {
        label: '公共状态',
        is_parent: true,
        key: 'public_status',
        children: [
            {
                label: '所有付款状态',
                key: 'all'
            },
            {
                label: '已提交',
                key: 'submit'
            },
            {
                label: '打款成功',
                key: 'success'
            },
            {
                label: '非提交或成功状态',
                key: 'others'
            },
        ]
    },
    {
        label: '云账户状态',
        is_parent: true,
        key: 'yzh',
        children: [
            {
                label: '打款失败(校验不通过)',
                key: 'valid_fail'
            },
            {
                label: '待打款(未签约/余额不足等)',
                key: 'manual_pending'
            },
            {
                label: '付款中(无需处理)',
                key: 'paying'
            },
            {
                label: '等待中(无需处理)',
                key: 'pending'
            },
            {
                label: '打款失败(支付被退回)',
                key: 'pay_fail'
            },
            {
                label: '打款失败(取消支付)',
                key: 'cancel'
            },
            {
                label: '未知状态',
                key: 'unknown'
            }
        ]
    },
    {
        label: 'CBS状态',
        is_parent: true,
        key: 'cbs',
        children: [
            {
                label: '中心手工录入后需人工复核',
                key: 'AC'
            },
            {
                label: '待预处理',
                key: 'AD'
            },
            {
                label: '审批否决',
                key: 'AE'
            },
            {
                label: '确认支付失败',
                key: 'AF'
            },
            {
                label: '待审批',
                key: 'AM'
            },
            {
                label: '待支付重发审批',
                key: 'AN'
            },
            {
                label: '业务撤消',
                key: 'AQ'
            },
            {
                label: '待企业审批',
                key: 'AW'
            },
            {
                label: '支付信息有误',
                key: 'BE'
            },
            {
                label: '银行支付失败',
                key: 'BF'
            },
            {
                label: '直联支付中',
                key: 'BP'
            },
            {
                label: '状态可疑',
                key: 'BQ'
            },
            {
                label: '银行退票',
                key: 'BR'
            },
            {
                label: '已提交直联接口进行支付',
                key: 'BT'
            },
            {
                label: '待银行答复',
                key: 'BW'
            },
            {
                label: '客户处理中',
                key: 'CC'
            },
            {
                label: '客户撤消',
                key: 'CD' 
            },
            {
                label: '客户审批否决',
                key: 'CF' 
            },
            {
                label: '已取消支付',
                key: 'CL' 
            },
            {
                label: '待中心处理',
                key: 'CP' 
            },
            {
                label: '部分成功',
                key: 'DB' 
            },
            {
                label: '待银保通支付',
                key: 'EP' 
            },
            {
                label: '银保通支付中',
                key: 'ET' 
            },
            {
                label: '分公司取消',
                key: 'GC' 
            },
            {
                label: '部分成功',
                key: 'GD' 
            },
            {
                label: '文件导出',
                key: 'GF' 
            },
            {
                label: '中意可疑状态',
                key: 'GQ' 
            },
            {
                label: '待人工确认',
                key: 'MC' 
            },
            {
                label: '过期',
                key: 'OD' 
            },
            {
                label: '待票据打印',
                key: 'PP' 
            },
            {
                label: '等待刷新',
                key: 'RW' 
            }
        ]
    }
]